import clsx from 'clsx';
import { CloseIcon } from 'components/icons/CloseIcon';
import { ModalContext } from 'context/ModalContext';
import { useContext, useState } from 'react';
import api from 'services/api';
import { MODAL_ANIMATIONS, MODAL_TYPES } from '../constants';

interface ICreatePlaylist {
  selectedChannel: any;
  videoId: string;
  videoHashId: string;
}

const CreatePlaylist = (props: ICreatePlaylist) => {
  const [playlistName, setPlaylistName] = useState('');
  const [description, setDescription] = useState('');
  const { showModal, hideModal } = useContext(ModalContext);
  const [errorMessage, setErrorMessage] = useState(false);

  const createPlaylist = () => {
    api
      .post('api/videos/playlist/create/', {
        channel: props.selectedChannel.hash_id,
        name: playlistName,
        description
      })
      .then(() => {
        if (props.videoId && props.videoHashId) {
          showModal(MODAL_TYPES.select_playlist, {
            animation: MODAL_ANIMATIONS.fade,
            selectedChannel: props.selectedChannel,
            videoId: props.videoId,
            videoHashId: props.videoHashId
          });
        } else {
          hideModal();
        }
      })
      .catch(() => {
        setErrorMessage(true);
      });
  };

  const closeCreatePlaylist = () => {
    if (props.videoId && props.videoHashId) {
      showModal(MODAL_TYPES.select_playlist, {
        animation: MODAL_ANIMATIONS.fade,
        selectedChannel: props.selectedChannel,
        videoId: props.videoId,
        videoHashId: props.videoHashId
      });
    } else {
      hideModal();
    }
  };

  return (
    <div className="transparent font-lato">
      <div className="relative border bg-gray-bg-dark border-gray-300 rounded-lg bg-white pb-7 pt-9 px-7 w-screen md:w-[622px] md:max-h-[508px]">
        <div className="flex">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Create a Collection</span>
          <CloseIcon
            className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100"
            onClick={closeCreatePlaylist}
          />
        </div>
        <p className="mb-3 font-bold mt-7">Name</p>
        <input
          type="text"
          value={playlistName}
          className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
          onChange={(e) => setPlaylistName(e.target.value)}
        />
        {errorMessage && <p className="mb-2 text-red-500">Name already exists.</p>}
        <p className="mb-3 font-bold">Description (optional)</p>
        <input
          type="text"
          className="px-4 py-2 w-full mb-8 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
          onChange={(e) => setDescription(e.target.value)}
        />
        <div
          className={clsx('w-40 h-11 rounded-[10px] text-base font-bold flex items-center justify-center', {
            'bg-buttonDisabledBg text-buttonDsiabledTxt pointer-events-none': !playlistName,
            'bg-green-600 cursor-pointer text-white ': playlistName
          })}
          onClick={createPlaylist}
        >
          Create
        </div>
      </div>
    </div>
  );
};

export default CreatePlaylist;
